export const parentLinks = {
  YOURPROFILE: 'Your profile',
  FINDACAR: 'Find a car',
  PARTEXCHANGE: 'Part exchange',
  VALUEMYCAR: 'Value my car',
  CARCARE: 'Car care',
  CARFINANCE: 'Car finance',
  HOWCINCHWORKS: 'How cinch works',
  NEWCAROFFERS: 'New car offers',
  USEDCARS: 'Used Cars',
  NEWCARS: 'New Cars',
} as const
